export class DateConstants {
    public static readonly DateFormat_RU = 'DD.MM.YYYY';
    public static readonly DateTimeFormat_RU = 'DD.MM.YYYY HH:mm';

    public static readonly DateTimeFormat_NativeInput = 'YYYY-MM-DDTHH:mm';
}
